/**
 * 我的项目
 */
<template>
  <div style="margin-top: 20px;">
      <!-- 左边导航 -->
      <div style="margin-bottom: 12px;font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
        <div class="mouse">项目列表</div>
      </div> 
      <!-- 右侧按钮 -->
      <div style="float: right;display: flex;">
        <el-button size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
        <el-button size="small" icon="el-icon-plus" class="clue-btn" @click="handleEdit">新的项目</el-button>
        <el-button v-if="downloadProjectAuth"  size="small" icon="el-icon-bottom" class="clue-btn" @click="checkDownLoad">表格下载</el-button>
        <el-button v-if="importProjectAuth" size="small" icon="el-icon-top" class="clue-btn" @click="handleImport">表格上传</el-button>
        <el-button size="small" icon="el-icon-delete" class="clue-btn" @click="delProjectCheck">删除</el-button>
        <!-- <el-input v-model="formInline.search" placeholder="请输入需要查询的条件" clearable class="clue-search">
          <el-button slot="append" icon="el-icon-search" class="clue-search-btn"></el-button>
        </el-input> -->
      </div>
    <!--项目列表-->
    <el-table size="small" :data="projectData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60" fixed="left">
      </el-table-column>
      <el-table-column prop="project_name" align="center" label="项目名称" width="210" fixed="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="项目信息编辑" @click="handleEdit(scope.$index, scope.row)">{{ scope.row.project_name }}</span>
          </template>
      </el-table-column>
      <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="project_money" align="center" label="预计立项金额(万元)" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="charge_type_view" align="center" label="收费方式" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="是否立项" :formatter="matterStatus" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="contacts" align="center" label="联系人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="admin_name" align="center" label="当前跟进人" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="desc" align="center" label="合同扫描件" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="annex" align="center" label="合同扫描件" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.is_annex" style="color: #407AA8;cursor: pointer;" title="查看合同扫描件" @click="previewAnnex(scope.$index, scope.row)">查看</span>
            <span v-else>未上传</span>
          </template>
      </el-table-column>
      <el-table-column prop="desc" align="center" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" width="120" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column align="center" label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" :disabled="scope.row.able" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" :disabled="scope.row.able" @click="delProject(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 项目编辑 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="projectFormVisible" width="850px" @click="closeDialog('projectForm')">
      <el-form label-width="120px" :model="projectForm" :rules="projectFormRule" ref="projectForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="project_name"> 
              <el-input size="small" v-model.trim="projectForm.project_name" auto-complete="off" clearable placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item label="预计立项金额" prop="project_money"> 
              <el-input size="small" v-model.trim="projectForm.project_money" auto-complete="off" unit="万元" clearable placeholder="请输入预计金额">
                <i slot="suffix" style="font-style: normal;margin-right: 4px;">万元</i>
              </el-input>
            </el-form-item>
            <el-form-item label="收费方式" prop="charge_type" class="feeType">
              <el-select size="small" v-model.trim="projectForm.charge_type" style="width: 60%;" placeholder="请选择" @change="changeFeeType">
                <el-option v-for="type in feeType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
              <el-input size="small" v-model="projectForm.type_value" auto-complete="off" style="width: 40%;margin-left: 4px;">
                <i slot="suffix" style="font-style: normal;margin-right: 4px;">{{ unit }}</i>
              </el-input>
            </el-form-item>
            <el-form-item label="是否立项" prop="status"> 
              <el-radio-group type="kind" v-model="projectForm.status"> 
                <el-radio v-model="projectForm.status" :label="1" style="font-size: 25px">是</el-radio>
                <el-radio v-model="projectForm.status" :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="客户名称" prop="customer_name"> 
              <el-input size="small" v-model.trim="projectForm.customer_name" auto-complete="off" clearable placeholder="请输入客户名称"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts"> 
              <el-input size="small" v-model.trim="projectForm.contacts" auto-complete="off" clearable placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="mobile"> 
              <el-input size="small" v-model.trim="projectForm.mobile" auto-complete="off" clearable placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <el-form-item label="上传合同">
              <div style="display: flex;">
                <el-upload
                    :action=uploadAnnex
                    :headers=setHeader
                    :show-file-list="false"
                    :before-upload="beforeFileTypeCheck"
                    :on-success="handleSuccessAnnex"
                >
                <el-button size="small" type="primary" title="请上传项目合同扫描件pdf">上传
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
                </el-upload>
                <el-button v-if="annex" size="small" type="success" style="margin-left: 20px;height: 32px;margin-top: 5px;" title="预览上传附件" @click="previewAnnex">
                  查看
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="合同列表" v-if="annexData.length > 0"> 
          <div v-for="item in annexData">
              <span>合同 - {{ item.annex_id }}</span>
              <span style="margin-left: 10px;color: #409EFF;cursor: pointer;" @click="viewAnnex(item.annex)">查看</span>
              <span style="margin-left: 20px;color: #409EFF;cursor: pointer;" @click="delAnnex(item.annex_id)">删除</span>
          </div>
        </el-form-item>
        <el-form-item label="项目备注" prop="desc"> 
          <el-input size="small" v-model.trim="projectForm.desc" auto-complete="off" clearable placeholder="请输入项目备注"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="editProject('projectForm')">确认</el-button>
            <el-button size="mini" @click="closeDialog('projectForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 项目导入 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="importFormVisible" width="850px" @click="closeDialog('importForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx或xls文件，且不超过10M
                    <span style="margin-left: 15px;color: #551A8B;cursor: pointer;" title="下载项目导入excel模板" @click="downloadImportExcel()">下载项目模板</span>
                  </div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <div class="rightDrawer" @click="handleDrawerOpen">
      《《
    </div>
    <el-drawer 
    :visible.sync="drawer" 
    :direction="direction" 
    :before-close="handleDrawerClose" 
    size="360px" 
    title="条件查询" 
    :show-close="false"
    :wrapperClosable="true"
    class="searchDrawer" 
    >
      <div style="margin-left: 20px;">
          <el-form :inline="true" :model="formInline">
            <el-form-item label="模糊查询" style="width: 320px;">
              <el-input size="small" v-model.trim="formInline.search" placeholder="请输入查询值" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" style="width: 320px;">
              <el-input size="small" v-model.trim="formInline.project_name" placeholder="请输入项目名称" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="客户名称" style="width: 320px;">
              <el-input size="small" v-model.trim="formInline.customer_name" placeholder="请输入客户名称" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="跟进商务" style="width: 320px;">
               <el-select size="small" v-model.trim="formInline.admin_id" placeholder="请选择" filterable clearable style="width: 250px;">
                  <el-option v-for="type in searchSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人员" style="width: 320px;">
              <el-input size="small" v-model.trim="formInline.name" placeholder="请输入联系人" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="searchProject">查询</el-button>
              <el-button type="warning" size="small" @click="resetSearch">重置</el-button>
              <el-button type="danger" size="small" @click="handleDrawerClose">关闭</el-button>
            </el-form-item>
          </el-form>
      </div>
    </el-drawer>
    <!-- 合同扫描件预览 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="annexVisbile" width="850px" height="400px">
      <iframe :src="annex" style="width: 800px;height: 600px;"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { 
  getProject, 
  editProject, 
  delProject, 
  downloadProject, 
  webUrl, 
  getImportProjectExcel, 
  getAuthAdmin,
  delProjectCheck,
  delAnnex
 } from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      loading: false, //是显示加载
      projectFormVisible: false, //控制编辑页面显示与隐藏
      importFormVisible: false, //控制导入界面显示与隐藏
      annexVisbile: false, //控制合同扫描件页面显示与隐藏
      title: '预览',
      // 按钮权限 --- 开始 ---
      addProjectAuth: true, //添加项目
      importProjectAuth: false, //导入项目(表格上传)
      downloadProjectAuth: false, //导出项目(表格下载)
      // 线索权限按钮

      multipleSelection: [],

      projectForm: {
        id: '',
        project_name: '',
        customer_name: '',
        contacts: '',
        mobile: '',
        project_money: '',
        charge_type: '',
        type_value: '',
        status: '',
        desc: '',
        annex: ''
      },
      importForm: {

      },
      formInline: {
        page: 1,
        ps: 15,
        search: '',
        customer_name: '',
        project_name: '',
        admin_id: '',
        name: ''
      },
      feeType: [
        { key: '比例收费', value: '比例收费' },
        { key: '定额收费', value: '定额收费' },
        { key: '其他', value: '其他' },
      ],
      // 收费方式单位
      unit: '',
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      // 项目附件(url地址)
      annex: '',
      // 项目合同保存地址
      save_annex: '',
      // 项目合同
      annexData: [],

      // 导入项目
      uploadExcel:webUrl + '/admin/project/importProject',
      // 上传项目附件(合同扫描件)
      uploadAnnex:webUrl + '/admin/project/uploadAnnexFile',
      userparm: [], //搜索权限
      listData: [], //用户数据
      projectData: [], //项目数据
      // 商务列表(查询)
      searchSeller: [],
       // 参数校验
      projectFormRule: {
        project_name:[{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        customer_name:[{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        contacts:[{ required: true, message: '请输入联系人', trigger: 'blur' }],
        mobile:[{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        project_money:[{ required: true, message: '请输入预计金额', trigger: 'blur' }],
        charge_type:[{ required: true, message: '请输入收费方式', trigger: 'blur' }],
        status:[{ required: true, message: '请选择是否立项', trigger: 'blur' }],
      },

      // 搜索框开始
      drawer: false,
      direction: 'rtl',
      // 搜索框结束

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
    // if(btnAuth.includes("myProjectAuth")){
    //   this.myProjectAuth = true
    //   this.myProjectAuthCh = true
    //   this.getMyCluePageList()
    // }
    // if(btnAuth.includes("projectManageAuth")){
    //   this.projectManageAuth = true
    //   if(!this.myProjectAuth){
    //     this.projectManageAuthCh = true
    // }}
    if(btnAuth.includes("importProjectAuth")){
      this.importProjectAuth = true
    }
    if(btnAuth.includes("downloadProjectAuth")){
      this.downloadProjectAuth = true
    }
    this.getProjectPageList()
    this.getSellerSelectData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.importFormVisible = false
          this.getProjectPageList()
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    // 视频上传oss 结束
    beforeFileTypeCheck(file) {
      const that = this
       if (!/\.(pdf|PDF)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '请上传合同扫描件pdf文件'
          })
          return false
        }
    },
    // 项目附件上传成功
    handleSuccessAnnex(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.annex = response.data.url
          this.save_annex = response.data.save_url
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },


    // 获取项目列表
    getProjectPageList() {
      this.loading = true
      getProject(this.formInline)
      .then(res=>{
        if(res.code == 200){
            this.projectData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
        }
      })
    },
    // 控制是否显示编辑页面
    handleEdit(index, row) {
      if(row){
        if(row.able){
          this.$message({
            type: 'warning',
            message: '您无权查看!'
          })
          return false
        }
        this.title = '编辑项目'
        this.projectForm.id = row.id
        this.projectForm.project_name = row.project_name
        this.projectForm.customer_name = row.customer_name
        this.projectForm.contacts = row.contacts
        this.projectForm.mobile = row.mobile
        this.projectForm.project_money = row.project_money
        this.projectForm.charge_type = row.charge_type
        this.projectForm.status = row.status
        this.projectForm.type_value = row.type_value
        this.unit = row.unit
        this.projectForm.desc = row.desc
        this.annex = row.annex
        this.projectFormVisible = true
        this.annexData = row.annexData
      }else{
        this.title = '添加项目'
        this.projectForm.id = ''
        this.projectForm.project_name = ''
        this.projectForm.customer_name = ''
        this.projectForm.contacts = ''
        this.projectForm.mobile = ''
        this.projectForm.project_money = ''
        this.projectForm.charge_type = ''
        this.projectForm.status = ''
        this.projectForm.desc = ''
        this.annex = ''
        this.unit = ''
        this.projectFormVisible = true
        this.annexData = []
      }
      this.save_annex = ''
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getProjectPageList(this.formInline)
    },
      // 刷新页面数据
    refreshData() {
      this.getProjectPageList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 编辑项目
    editProject(projectForm) {
      this.$refs[projectForm].validate(valid => {
        if(valid){
          this.projectForm.annex = this.save_annex
          editProject(this.projectForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.projectFormVisible = false
              this.getProjectPageList()
            }else{
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
        }else{
          return false
        }
      })
    },
    // 收费方式改变
    changeFeeType(type) {
      if(type == '比例收费'){
        this.unit = '%'
      }else if(type == "定额收费"){
        this.unit = '万元'
      }else if(type == '其他'){
        this.unit = ''
      }
    },
    matterStatus: function(obj) {
      if(obj.status == 1){
          return '是'
      }else if(obj.status == 2){
          return '否'
      }else{
          return '其他'
      }
    },
    // 删除项目(勾选中的项目) 
    delProjectCheck() {
      let checkIds = this.multipleSelection
      const idsArr = [];
      let isAble = false
      let that = this
      if(checkIds.length <= 0){
        that.$message({
          type: 'warning',
          message: '暂无勾选任何数据!'
        })
        return false
      }
      checkIds.forEach(function(item,index){
        if(item.able){
           isAble = true
        }else{
          idsArr.push(item.id)
        }
      })
      if(isAble){
         that.$message({
          type: 'warning',
          message: '勾选数据存在您无权操作的数据!'
        })
        return false
      }
      that.$confirm('确定要删除勾选中的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        const idStr = JSON.stringify(idsArr)
        delProjectCheck({ids: idStr})
        .then(res=>{
          if(res.code == 200){
            that.$message({
              type: 'success',
              message: res.msg
            })
            that.getProjectPageList()
          }else{
            that.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除项目
    delProject(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delProject({id: row.id})
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getProjectPageList()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
      })
      .catch(() => {
        this.loading = false
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    // 导出勾选中的数据 
    checkDownLoad() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
          })
          return false;
      }
      this.$confirm('确定导出勾选的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(()=>{
        const idStr = JSON.stringify(idsArr)
          downloadProject({ids: idStr})
          .then( res=> {
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
              window.location.href = res.data.url
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
      })
      .catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示导入页面是否显示
    handleImport() {
      this.title = '项目导入'
      this.importFormVisible = true
    },
    // 下载导入模板
    downloadImportExcel() {
      getImportProjectExcel()
      .then(res=>{
        if(res.code == 200){
          console.log(res)
          this.$message({
            type: 'success',
            message: '模板下载成功!'
          })
          window.location.href = res.data.url
        }else{
          this.$message({
            type: 'error',
            message: '模板下载失败!'
          })
        }
      })
    },
    // 开启搜索框
    handleDrawerOpen() {
      this.drawer = true
    },
    // 关闭搜索框
    handleDrawerClose() {
      this.drawer = false
    },
    // 项目搜索
    searchProject() {
      // console.log(this.formInline)
      this.formInline.page = 1
      this.getProjectPageList()
    },
    // 查询商户(查询)
    getSellerSelectData() {
      getAuthAdmin()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.searchSeller = res.data
        }
      })
    },
    // 搜索重置
    resetSearch() {
      this.formInline.search = ''
      this.formInline.admin_id = ''
      this.formInline.customer_name = ''
      this.formInline.project_name = ''
      this.formInline.name = ''
      this.formInline.page = 1
      this.getProjectPageList()
    },
    // 预览项目附件(合同扫描件)
    previewAnnex(index, row) {
      // let annexUrl = this.annex
      // console.log(annexUrl)
      if(row){
        if(row.able){
          this.$message({
            type: 'warning',
            message: '您无权查看!'
          })
          return false
        }
        this.annex = row.annexData[0].annex
      }
      this.title = '合同扫描件预览'
      this.annexVisbile = true
    },
    // 预览合同
    viewAnnex(annex){
      window.open(annex,'_blank')
    },
    // 删除合同
    delAnnex(id){
      // 确认是否删除
      this.$confirm('确定要删除合同吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delAnnex({id: id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.projectFormVisible = false
            this.getProjectPageList()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    // 关闭编辑、增加弹出框0
    closeDialog(formName) {
      if(formName == 'projectForm'){
        this.projectFormVisible = false
      }
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.clue-btn {
  background-color: #333333;
  color: #FFFFFF;
}
.clue-search {
  margin-left: 20px;
  background-color: #E4E4E4;
}
.clue-search-btn {
  background-color: #333333 !important;
  color: #FFFFFF !important;
  font-weight: 700 !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.u-btn {
  display: none;
}
.mouse {
  cursor: pointer;
}
.feeType>>>.el-form-item__content{
  display: flex !important;
}
.rightDrawer {
  width: 40px;
  height: 100px;
  background-color: #00C8DF;
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  left: auto;
  right: 0;
  top: 40%;
  z-index: 10;
  color: #FFFFFF;
  text-align: center;
  margin-top: auto;
  line-height: 100px;
  cursor: pointer;
}
.searchDrawer {
  height: 80vh;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 20px 0px 0px 20px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/crm/project.vue